import React from 'react'

function Main() {
  return (
    <div className='box-2'>
    <ul>
      <li><a href="#home">Home</a></li>
      <li><a href="https://barbaroreyes.github.io/First-Responsive-WebsiteBarbaro/">About</a></li>
      <li><a href="https://barbaroreyes.github.io/tablas/">Portfolio</a></li>
      <li><a href="#Ch">Contact</a></li>
      </ul>
    </div>
  )
}

export default Main
